/* API-lager för KanAI-artefakter (LF-5): ett KanAI-svar sparat som
   markdown-dokument i projektets Dokument-modul, mappen "KanAI-svar".
   Kontrakt: POST/GET/PUT /api/kanai/artifacts. Alla anrop går via apiFetch
   (cookie + X-Tenant-Slug). Fel kastas som Error med backendens detail-text
   och HTTP-status på err.status, så anroparen kan visa t.ex. 403-texten. */
import { API_URL, apiFetch } from "../../api";

const ARTIFACTS_URL = `${API_URL}/api/kanai/artifacts`;

/* FastAPI skickar detail som sträng, som lista (422) eller som objekt. */
function formatDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === "string" ? d : d?.msg || ""))
      .filter(Boolean)
      .join("; ");
  }
  if (typeof detail === "object" && detail.msg != null) return String(detail.msg);
  try { return JSON.stringify(detail); } catch { return String(detail); }
}

async function toError(res, fallback) {
  let msg = fallback;
  try {
    const data = await res.json();
    const text = formatDetail(data?.detail);
    if (text) msg = text;
  } catch { /* ingen JSON-kropp, behåll fallback */ }
  const err = new Error(msg);
  err.status = res.status;
  return err;
}

async function request(url, options, fallback) {
  const res = await apiFetch(url, options);
  if (!res.ok) throw await toError(res, fallback);
  if (res.status === 204) return null;
  return res.json();
}

function jsonBody(method, body) {
  return { method, headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) };
}

/** Spara ett svar som artefakt. payload enligt kontraktet:
 *  { project_id, title, content_markdown, question, sources, conversation_id, mode_id, folder_id } */
export async function createArtifact(payload) {
  return request(ARTIFACTS_URL, jsonBody("POST", payload), "Kunde inte spara svaret i projektet");
}

/** Lista projektets artefakter. */
export async function listArtifacts(projectId) {
  const url = `${ARTIFACTS_URL}?project_id=${encodeURIComponent(String(projectId))}`;
  return request(url, { method: "GET" }, "Kunde inte hämta sparade svar");
}

/** Hämta en artefakt inkl. content_markdown och versionslista. */
export async function getArtifact(id) {
  const url = `${ARTIFACTS_URL}/${encodeURIComponent(String(id))}`;
  return request(url, { method: "GET" }, "Kunde inte hämta det sparade svaret");
}

/** Ny version av innehållet: { content_markdown, comment }. */
export async function updateArtifact(id, payload) {
  const url = `${ARTIFACTS_URL}/${encodeURIComponent(String(id))}`;
  return request(url, jsonBody("PUT", payload), "Kunde inte uppdatera det sparade svaret");
}
